/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Redeem_DescriptionInputs */

const en_common_sign_redeem_description = /** @type {(inputs: Common_Sign_Redeem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This app is invite-only. Enter a valid invite code to continue.`)
};

const zh_common_sign_redeem_description = /** @type {(inputs: Common_Sign_Redeem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本应用为邀请制,请输入有效的邀请码以继续。`)
};

/**
* | output |
* | --- |
* | "This app is invite-only. Enter a valid invite code to continue." |
*
* @param {Common_Sign_Redeem_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_redeem_description = /** @type {((inputs?: Common_Sign_Redeem_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Redeem_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_redeem_description(inputs)
	return zh_common_sign_redeem_description(inputs)
});
export { common_sign_redeem_description as "common.sign.redeem_description" }